// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Calendar: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 14 16"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M12.5 2H11V.972C11 .45 10.55 0 10 0S9 .45 9 .972V2H5V.972C5 .45 4.55 0 4 0S3 .45 3 .972V2H1.5A1.5 1.5 0 000 3.5V5h14V3.5A1.5 1.5 0 0012.5 2zM0 14.5A1.5 1.5 0 001.5 16h11a1.5 1.5 0 001.5-1.5V6H0v8.5z" />
        </svg>
    );
};

export default React.memo(Calendar);
